import { initializeApp } from "firebase/app";


import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  updateEmail,
  updatePassword,
  EmailAuthProvider,
  reauthenticateWithCredential,
  User // Import User type for better type safety
} from "firebase/auth";
import { getFirestore, query, getDoc, collection, where, doc, updateDoc, DocumentSnapshot, DocumentData } from "firebase/firestore"; // Added DocumentSnapshot, DocumentData
import { createDocument } from './firestoreservice'; // Corrected path
import { getStorage } from "firebase/storage";
// Removed: import { doc, updateDoc } from "firebase/firestore"; // Already imported above


const firebaseConfig = {
  apiKey: "AIzaSyAwRC9aw8fFfTkm-hl7pjR5_CTB2leohOI",
  authDomain: "web-construct-app.firebaseapp.com",
  projectId: "web-construct-app",
  storageBucket: "web-construct-app.appspot.com",
  messagingSenderId: "576412080434",
  appId: "1:576412080434:web:fbdd24284ee1d316e65f2b",
  measurementId: "G-JZJCSM78J4"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // initialize Firebase Storage
const googleProvider = new GoogleAuthProvider();

const signInWithGoogle = async (): Promise<void> => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;

    localStorage.setItem('display_name', user.displayName || '');
    localStorage.setItem('profile_image_url', user.photoURL || '');
    localStorage.setItem('user_uid', user.uid);
    localStorage.setItem('email', user.email || '');

   const userRef = doc(db, "users", user.uid);
   const docSnap: DocumentSnapshot<DocumentData> = await getDoc(userRef);
   if (docSnap.exists()) {
     console.log("Document already exists, skipping creation");
     const userData = docSnap.data();
     const updatedUser = { 
       uid: user.uid,
       displayName: user.displayName,
       photoURL: user.photoURL,
       email: user.email,
       ...userData 
      }; // Ensure all necessary fields are included
     localStorage.setItem("user", JSON.stringify(updatedUser));
     return;
   }

   await createDocument("users", {
     uid: user.uid,
     name: user.displayName,
     authProvider: "google",
     email: user.email,
   });

 } catch (error: any) {
   console.error("Error signing in with Google: ", error);
 }
};

const logInWithEmailAndPassword = async (email: string, password: string): Promise<void> => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err: any) {
    console.error(err);
    alert(err.message);
  }
};

const registerWithEmailAndPassword = async (name: string, email: string, password: string): Promise<void> => {
  try {
    console.log('Creating user with email and password');
    const res = await createUserWithEmailAndPassword(auth, email, password);
    console.log('User created with email and password, response:', res);

    const user = res.user;
    if (user) {
      const uid = user.uid;
      console.log('UID:', uid); 
      const data = {
        uid,
        name,
        authProvider: "local",
        email,
      };
      await createDocument("users", data);
    } else {
      throw new Error('No user is created');
    }
  } catch (err: any) {
    console.error('Error while registering user:', err);
    alert(err.message);
  }
};

const sendPasswordReset = async (email: string): Promise<void> => {
  // Never reveal whether the address exists (no divergent alert on success vs
  // auth/user-not-found) and never surface raw Firebase errors to the user.
  // Resolve regardless so the caller can show one neutral message; log real
  // errors for ourselves only.
  try {
    await sendPasswordResetEmail(auth, email);
  } catch (err: any) {
    console.error('sendPasswordReset failed:', err?.code || err);
  }
};

const logout = (): void => {
  signOut(auth);
};

const updateEmailForUser = async (user: User, email: string, password: string): Promise<void> => {
  if (!user.email) { // Add a check for user.email
    console.error("User's current email is not available.");
    alert("User's current email is not available for re-authentication.");
    return;
  }
  console.log('user.email:', user.email);
  console.log('New Email:', email);
  console.log('password:', password);

  const credential = EmailAuthProvider.credential(user.email, password);
  await reauthenticateWithCredential(user, credential);
  await updateEmail(user, email);

    const userDocRef = doc(db, "users", user.uid);
    await updateDoc(userDocRef, { email: email });
};

const updatePasswordForUser = async (user: User, newPassword: string, currentPassword: string): Promise<void> => {
  if (!user.email) { // Add a check for user.email
    console.error("User's current email is not available.");
    alert("User's current email is not available for re-authentication.");
    return;
  }
  const credential = EmailAuthProvider.credential(user.email, currentPassword);
  await reauthenticateWithCredential(user, credential);
  await updatePassword(user, newPassword);
};

export {
  app,
  auth,
  db,
  storage,
  signInWithGoogle,
  logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  sendPasswordReset,
  logout,
  updateEmailForUser,
  updatePasswordForUser,
  EmailAuthProvider
}; 